import { createContext, useContext } from 'react';

/** Controls for the "Show Original Content" toggle, surfaced inline in `DiffLegend` without prop-drilling through the nested preview tables. */
export interface ViewBeforeControls {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  /** Disables the toggle — e.g. the platform connection needed for before-data isn't active. */
  disabled?: boolean;
  /** Tooltip shown while disabled, explaining why and how to unblock it. */
  disabledTooltip?: string;
}

/** Wrap a preview subtree in `<ViewBeforeCtx.Provider>` so its `DiffLegend` renders the toggle inline, with state owned by the page. */
export const ViewBeforeCtx = createContext<ViewBeforeControls | null>(null);

/** Reads the ambient "Show Original Content" controls; returns null when no provider is present (legend renders alone). */
export function useViewBefore(): ViewBeforeControls | null {
  return useContext(ViewBeforeCtx);
}
